<!--
功能：京东订单
-->
<template>
  <div class="JDOrders">
    <div class="page-title">京东订单</div>
    <!-- 表单查询 -->
    <el-form ref="queryFormRef" class="query-form" :model="queryForm" inline>
      <el-form-item label="最后修改日期">
        <date-range :timeDate.sync="timeDate" @dateValue="changeTime($event,'last')" :thisClearable="'true'"></date-range>
      </el-form-item>
      <el-form-item label="付款日期">
        <date-range :timeDate.sync="payTime" @dateValue="changeTime($event,'pay')" :thisClearable="'true'"></date-range>
      </el-form-item>
      <el-form-item label="PID" prop="pid">
        <el-input v-model="queryForm.pid" placeholder="请输入PID" @blur="changeTime()" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="授权ID" prop="authId">
        <el-input v-model="queryForm.authId" placeholder="请输入授权ID" @blur="changeTime()" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="付款状态" prop="validCode">
        <el-select v-model="queryForm.validCode" @change="changeTime()" filterable clearable placeholder="请选择付款状态">
          <el-option v-for="item in validCodeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" prop="searchName">
        <el-input v-model="queryForm.searchName" placeholder="请输入店铺名称" class="input-with-search" style="width:230px;">
          <el-button @click="changeTime()" slot="append" icon="iconfont icon-sousuo"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button @click="resetForm" size="medium" type="info">重置选项</el-button>
      </el-form-item>
    </el-form>
    <div class="dataStatistics">
      <p>总订单数<span>{{ dataStatistics.totalOrderNum ||0}}</span></p>
      <p>付款金额<span>{{ dataStatistics.totalPayAmount||0}}</span></p>
      <p>退款订单数<span>{{ dataStatistics.refundOrderNum||0}}</span></p>
      <p>退款金额<span>{{ dataStatistics.refundPayAmount||0}}</span></p>
      <p>退款率(%)<span>{{ dataStatistics.refundRadio||0}}</span></p>
    </div>
    <el-button @click="download" :disabled="tableData.length == 0" type="primary" size="medium" icon="iconfont icon-xiazai-copy">下载报表</el-button>
    <!-- 表格 -->
    <el-table ref="tableRef" class="roleTable" :data="tableData" max-height="tabheight" border v-loading="tableLoading">
      <el-table-column prop="modifyTime" label="订单修改时间" width="100"></el-table-column>
      <el-table-column prop="shopName" label="店铺名称" min-width="120"></el-table-column>
      <el-table-column prop="skuId" label="商品id" min-width="120"></el-table-column>
      <el-table-column prop="skuName" label="商品名称" min-width="120"></el-table-column>
      <el-table-column prop="pid" label="PID" min-width="120"></el-table-column>
      <el-table-column prop="adId" label="计划ID" min-width="120"></el-table-column>
      <el-table-column prop="jdId" label="订单ID" min-width="120"></el-table-column>
      <el-table-column prop="orderId" label="订单号" min-width="120"></el-table-column>
      <el-table-column prop="estimateCosPrice" label="付款金额"></el-table-column>
      <el-table-column prop="validCode" label="付款状态">
        <template slot-scope="scope">
          <div class="status">
            <span v-for="item in validCodeList" :key="item.label" :class="item.class">
              <span v-if="item.value===scope.row.validCode">{{ item.label }}</span>
            </span>
            <span v-if="validCode.indexOf(scope.row.validCode)===-1" class="grey">无效</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="orderTime" label="付款时间" width="95"></el-table-column>
      <el-table-column prop="authId" label="授权ID"></el-table-column>
      <el-table-column prop="enterpriseName" label="公司名称" min-width="120"></el-table-column>
      <el-table-column prop="status" label="匹配状态">
        <template slot-scope="scope">
          <div class="status">
            <span v-if="scope.row.status===1" class="green">成功</span>
            <span v-else-if="scope.row.status===2" class="red">匹配失败</span>
            <span v-else-if="scope.row.status===3" class="grey">无效订单</span>
            <span v-else>/</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="paging-box" v-if="pageTotal > 0">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80, 100]"
        @size-change="handleSizeChange"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="pageTotal">
      </el-pagination>
    </div>
  </div>
</template>
<script>
// 公用
import { handleTime, getTimeAll, downloadFile } from '@/components/public'
// 组件
import dateRange from './../../../components/common/dateRange'
export default {
  // 组件名称
  name: 'JDOrders',
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
    dateRange
  },
  // 组件状态值
  data () {
    return {
      userId: '', // 用户id
      timeDate: [handleTime(new Date(), 6), handleTime(new Date())],
      payTime: [],
      // 查询表单
      queryForm: {
        timeStart: '',
        timeEnd: '',
        pid: '',
        authId: '',
        searchName: '',
        validCode: '',
        pageNum: 1,
        pageSize: 10
      },
      pageTotal: 0,
      tabheight: null,
      // 表格数据
      tableData: [],
      tableLoading: false,
      dataStatistics: {
        refundOrderNum: 0,
        refundPayAmount: 0,
        refundRadio: 0,
        totalOrderNum: 0,
        totalPayAmount: 0
      },
      validCodeList: [{
        value: 15,
        label: '待付款',
        class: 'blur'
      }, {
        value: 16,
        label: '已付款',
        class: 'blur'
      }, {
        value: 17,
        label: '已完成',
        class: 'green'
      }, {
        value: 24,
        label: '已付定金',
        class: 'blur'
      }, {
        value: -1,
        label: '无效',
        class: 'grey'

      }],
      validCode: [15, 16, 17, 24]
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    getParam() {
      const param = this.queryForm
      if (this.timeDate) {
        param.timeStart = this.timeDate[0]
        param.timeEnd = this.timeDate[1]
      } else {
        param.timeStart = ''
        param.timeEnd = ''
      }
      if (this.payTime && this.payTime.length > 1) {
        param.payTimeStart = this.payTime[0]
        param.payTimeEnd = this.payTime[1]
      } else {
        param.payTimeStart = ''
        param.payTimeEnd = ''
      }
      console.log(param)
      return param
    },
    getPageData() {
      this.$service.post('/api/dsReport/order/jd/list', this.getParam()).then(res => {
        if (res.code === 200) {
          // 关闭tableLoading
          this.tableLoading = false
          if (res.result.pageData.pageData && res.result.pageData.pageData.length > 0) {
            res.result.pageData.pageData.forEach(item => {
              item.adId = item.adId || '/'
              item.modifyTime = getTimeAll(new Date(item.modifyTime))
              item.estimateCosPrice = item.estimateCosPrice || '/'
              item.orderTime = getTimeAll(new Date(item.orderTime))
            })
          }
          this.tableData = res.result.pageData.pageData
          this.pageTotal = res.result.pageData.total
          if (res.result.totalData) {
            res.result.totalData.refundRadio = this.floatMul(res.result.totalData.refundRadio, 100) + '%'
            this.dataStatistics = res.result.totalData
          }
          if (this.pageTotal > 5) {
            this.updatetabheight()
          } else {
            this.tabheight = null
          }
        }
      }).catch(Err => {
        this.tableLoading = false
      })
    },
    floatMul(arg1, arg2) {
      if (arg1.toString().indexOf('.') === -1) {
        arg1 += '.00'
      }
      if (arg2.toString().indexOf('.') === -1) {
        arg2 += '.00'
      }
      let m = 0
      const s1 = arg1.toString()
      const s2 = arg2.toString()
      try {
        m += s1.split('.')[1].length
      } catch (e) {}
      try {
        m += s2.split('.')[1].length
      } catch (e) {}
      return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m)
    },
    updatetabheight() {
      let height = document.documentElement.clientHeight
      let offsetTop = this.$refs.tableRef.$el.offsetTop
      this.$nextTick(() => {
        this.tabheight = parseInt(height - offsetTop - 83)
      })
    },
    // 切换分页
    handleCurrentChange (val) {
      this.queryForm.pageNum = val
      this.getPageData()
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      this.queryForm.pageSize = size
      this.getPageData()
    },
    // 选择时间获取表格数据
    changeTime (val, type) {
      // console.log('changeTime', val)
      if (val) {
        if (type === 'last') {
          this.timeDate = val
        } else if (type === 'pay') {
          this.payTime = val
        }
      }
      this.queryForm.pageNum = 1
      this.getPageData()
    },
    // 重置选项
    resetForm () {
      this.$refs.queryFormRef.resetFields()
      this.timeDate = [handleTime(new Date(), 6), handleTime(new Date())]
      this.getPageData()
    },
    download() {
      downloadFile('/api/dsReport/order/jd/list/download', this.getParam(), '京东订单 ')
    }
  },
  // 组件在内存中被创建
  created () {
  },
  /**
  * 组件被渲染到页面
  */
  mounted () {
    this.getPageData()
  }
}
</script>
<style lang="less">
@import './../../../styles/common/public.less';
  .JDOrders{
    .status{
      font-size: 12px;
      .el-button{
        height: 24px;
        line-height: 24px;
        padding: 0 8px;
      }
      .blue{
        color: @color;
      }
      .red{
        color: @red;
      }
      .grey{
        color: grey;
      }
    }
    .dataStatistics{
      display: flex;
      width: 90%;
      margin: auto;
      p{
        width: 25%;
        font-size: 16px;
        line-height: 1.5;
        text-align: center;
        color: #9c9f97;
        span{
          color: @color;
          font-weight: bold;
          display: block;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/report/ecReport/JDOrders.vue